import { contestActions } from './contestSlice';
import { fetchGet, fetchStaticJson, isCharedi } from '../../utils/utils';
import { isCompetitionEnded } from '../../ui/builders/utils';

const fetchContestDataFromApi = async (isAuth, schoolId, contestId) => {

  const staticResponse = await fetchGet(`${window.config.apiUrl}/Contest/staticInfo?contestId=${contestId}`);
  const staticData = staticResponse.body;
  if (isAuth && schoolId) {
    const statusResponse = await fetchGet(`${window.config.apiUrl}/Contest/status?schoolId=${schoolId}&contestId=${contestId}`);
    const statusData = statusResponse.body;
    return {
      ...staticData,
      ...statusData,
    };
  }


  return staticData;
};

export const fetchContestData = (isAuth, schoolId, contestId) => {
  return async (dispatch) => {
    try {
      dispatch(contestActions.setLoading(true));
      let data = await fetchContestDataFromApi(isAuth, schoolId, contestId);
      const contentInfo = await fetchContentInfoJson(contestId);
      if (data?.stages) {
        const currentStage = data.stages.find(stage => stage.isCurrent === true);
        if (currentStage && currentStage.name) {
          data.stage = currentStage.name;
        }
      }
      if (data?.finalData?.minutesUntilFinal != null) {
        const finalTargetDate = new Date(Date.now() + data.finalData.minutesUntilFinal * 60 * 1000);
        data = { ...data, finalData: { ...data.finalData, finalTargetDate: finalTargetDate.toISOString() } };
      }

      dispatch(contestActions.setContestState({ ...data, contentInfoJson: contentInfo, currentContestId: contestId, initContestData: true, isLoading: false }));
    } catch (error) {
      console.error('Error fetching contest data:', error);
      dispatch(contestActions.setLoading(false));
      dispatch(contestActions.setError('Error fetching contest data'));
      dispatch(contestActions.setInitContestData(true));
    }
  };
};

export const fetchActiveContests = (lang) => {
  return async (dispatch) => {
    try {
      const response = await fetchGet(`${window.config.apiUrl}/Contest/list`);
      let list = response?.body?.list ?? [];
      if (isCharedi()) {
        list = list.filter((contest) => contest.showCharedi === true);
        list = list.map((contest) => (contest.id === 14002) ? { ...contest, fromClass: 3, toClass: 6 } : contest
        );
      }
      dispatch(contestActions.setActiveContests(list));
    } catch (error) {
      console.error('[Contest] fetchActiveContests - Error:', error);
    }
  };
};

export const fetchContentInfoJson = async (contestId) => {
  try {
    const contestInfo = await fetchStaticJson(`${window.config.contestInfoFile}_${isCharedi() ? 'charedi_' : ''}${contestId}.json`);
    return contestInfo;
  } catch (error) {
    console.error('Error fetching content info JSON:', error);
    return null;
  }
};

export const fetchFinalStatus = (schoolId) => {
  return async (dispatch) => {
    if (!schoolId) return { ok: false };
    try {
      const response = await fetchGet(`${window.config.apiUrl}/Final/isAllowed?schoolId=${schoolId}`);
      const body = response?.body ?? null;
      if (!response?.ok || body == null)
        return { ok: false };
      const { isTeamMember, minutesUntilFinal, isFinalOpen, isFinalEnd, finalGameUrl } = body;
      dispatch(contestActions.setFinalStatus({ finalData: { minutesUntilFinal, isFinalOpen, isFinalEnd }, finalStatus: { isTeamMember } }));
      return { ok: true, finalStatus: { isTeamMember, minutesUntilFinal, isFinalOpen, isFinalEnd, finalGameUrl } };
    }
    catch (error) {
      console.error('Error fetching final status:', error);
      return { ok: false };
    }
  };
};

